import React from 'react';
import { connect } from 'react-redux';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import selector, { getOptionLabel, display, employeeDisplay, currency, numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import { useTranslation } from 'react-i18next';
import { toBoolean } from 'src/utils/Number';
import tableStyles from '../styles/GeneralTableInfo.scss';
import styles from './UnionDuesContributionSection.scss';

const UnionDuesContributionSectionShow = props => {
  const { employeeSsoSetting, unionDuesTypes, isUnionDuesContributions } = props;
  const { t } = useTranslation();
  const FIXED_AMOUNT_VALUE = 'fixed_amount';

  const isUnionDuesContribution = toBoolean(employeeSsoSetting?.isUnionDuesContribution);
  const isFixedAmount = employeeSsoSetting?.unionDuesType === FIXED_AMOUNT_VALUE;
  const unionDuesContributionOption = getOptionLabel(Number(isUnionDuesContribution).toString())(isUnionDuesContributions);

  return (
    <div className={styles.container}>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.SocialSecurityContribution.union_dues_contribution')}:</th>
            <td>{display(unionDuesContributionOption)}</td>
          </tr>
          {isUnionDuesContribution && (
            <React.Fragment>
              <tr>
                <th>{t('features.Employees.components.SocialSecurityContribution.union_dues_type')}:</th>
                <td>{employeeDisplay(getOptionLabel(employeeSsoSetting?.unionDuesType)(unionDuesTypes))}</td>
              </tr>
              {isFixedAmount && (
                <tr>
                  <th>{t('features.Employees.components.SocialSecurityContribution.union_dues_amount')}:</th>
                  <td>{currency(numberWithComma(decimalPlace2(employeeSsoSetting?.unionDuesAmount)))}</td>
                </tr>
              )}
            </React.Fragment>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeSsoSetting: selector(getItem(REDUCER_NAME, state), 'employeeSsoSetting'),
  unionDuesTypes: getSelectOptions(state, 'unionDuesTypes'),
  isUnionDuesContributions: getSelectOptions(state, 'isUnionDuesContribution')
});

export default connect(mapStateToProps)(UnionDuesContributionSectionShow);
